/* AdVille · i comportamenti delle pagine nuove di Vivo Vintage (stessi delle anteprime approvate).
   Galleria, barra d'acquisto fissa su telefono, lista d'attesa delle borse vendute, iscrizioni a Klaviyo, pop-up. */
/* ---------------------------------------------------------------- il ritorno alle liste (Angelo 03/11, la cliente da Instagram)
   Ogni lista (collezione, ricerca) ricorda dove si era e quale borsa era sullo schermo, per un'ora, nella memoria del
   telefono che resta anche se Instagram chiude e riapre il suo browser. Tornando a quella lista in qualunque modo (tasto o
   gesto indietro, menu, briciole, logo e poi la lista, il browser di Instagram riaperto) si riparte da lì. Riparte
   dall'inizio solo chi tocca la lista mentre ci sta già sopra, o chi non ci passa da più di un'ora.
   Sta in un blocco suo, prima di tutto il resto: un errore in un'altra parte del file non lo ferma. */
(function () {
  var DURATA = 60 * 60e3;
  var QUI = location.pathname + location.search;
  var LISTA = !!document.querySelector('[data-griglia]') || /^\/(search|collections\/[^\/]+\/?$)/.test(location.pathname);
  var FILE_LATERALI = '.av .scorri, .av .recensioni, .av .binario, .av .facce-g, .av .schede-coll, .av .fila';
  var radice = document.documentElement;
  function mostra() { radice.classList.remove('av-torno'); }

  // la memoria della scheda del browser è piccola (5 MB): se è piena si buttano le pagine ricordate delle altre liste e si riprova
  function salva(k, v) {
    try { sessionStorage.setItem(k, v); return true; } catch (x) {}
    try {
      Object.keys(sessionStorage).forEach(function (c) { if (c !== k && /^av_(altre|modello):/.test(c)) sessionStorage.removeItem(c); });
      sessionStorage.setItem(k, v); return true;
    } catch (y) { return false; }
  }
  window.avSalva = salva;

  // il punto di ogni lista: nel telefono (localStorage) e nella scheda del browser (sessionStorage)
  function chiave(u) { return 'av_lista:' + u; }
  function leggiLista(u) {
    var r = null;
    try { r = JSON.parse(localStorage.getItem(chiave(u)) || 'null'); } catch (x) {}
    if (!r) { try { r = JSON.parse(sessionStorage.getItem(chiave(u)) || 'null'); } catch (x) {} }
    return r && r.u === u && Date.now() - r.t < DURATA ? r : null;
  }
  function scriviLista(r) {
    var v = JSON.stringify(r);
    try {
      localStorage.setItem(chiave(r.u), v);
      Object.keys(localStorage).forEach(function (c) {
        if (c.indexOf('av_lista:') !== 0 || c === chiave(r.u)) return;
        var o = null; try { o = JSON.parse(localStorage.getItem(c)); } catch (x) {}
        if (!o || Date.now() - o.t > DURATA) localStorage.removeItem(c);
      });
    } catch (x) {}
    try { sessionStorage.setItem(chiave(r.u), v); } catch (x) {}
  }

  // la pagina mostrata prima di questa, in questa scheda del browser
  var ULTIMA = null;
  try { ULTIMA = sessionStorage.getItem('av_ultima'); sessionStorage.setItem('av_ultima', QUI); } catch (x) {}

  // la voce della cronologia ricorda le pagine aggiunte e il punto in cui si era: tornando indietro si rimette tutto com'era
  function statoAv(extra) {
    try { history.replaceState(Object.assign({}, history.state || {}, extra), ''); } catch (x) {}
  }
  function percorso(a) { try { return new URL(a.href, location.href).pathname; } catch (x) { return ''; } }

  // ---------------------------------------------------------------- «Vedi altre»: le schede aggiunte restano nella memoria
  var MEMORIA = 'av_altre:' + QUI;
  function memoria() { try { return JSON.parse(sessionStorage.getItem(MEMORIA) || '[]'); } catch (x) { return []; } }
  function aggiungiCarte(html, dopo) {
    var grid = document.querySelector('[data-griglia]'), a = document.querySelector('[data-vedi-altre]'), box = a && a.closest('[data-altre]');
    if (!grid) return;
    grid.insertAdjacentHTML('beforeend', html);
    var q = document.querySelector('[data-quanti]');
    if (q) q.textContent = grid.querySelectorAll('.av-card').length;
    if (a) { if (dopo) { a.href = dopo; a.textContent = 'Vedi altre'; } else if (box) { box.remove(); } }
  }
  function caricaAltre(url) {
    var a = document.querySelector('[data-vedi-altre]');
    if (a) a.textContent = 'Un attimo…';
    return fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html');
      var html = [].map.call(d.querySelectorAll('[data-griglia] > .av-card-box, [data-griglia] > .av-card'), function (c) { return c.outerHTML; }).join('');
      var nx = d.querySelector('[data-vedi-altre]');
      var pezzo = { u: url, html: html, dopo: nx ? nx.getAttribute('href') : '' };
      aggiungiCarte(pezzo.html, pezzo.dopo);
      return pezzo;
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vedi-altre]');
    if (!a) return;
    e.preventDefault();
    var u = a.href;
    caricaAltre(u).then(function (pezzo) {
      var gia = (history.state || {}).avPagine || [];
      statoAv({ avPagine: gia.concat([u]) });
      var m = gia.length ? memoria() : [];
      m.push(pezzo);
      salva(MEMORIA, JSON.stringify(m));
      fotografa(null);
    }).catch(function () { location.href = u; });
  });

  // ---------------------------------------------------------------- il punto: si fotografa scorrendo e toccando
  var ripristino = false, congela = 0, ultimo = null;
  function ancora(href) {
    if (!href) return null;
    return [].find.call(document.querySelectorAll('main a[href]'), function (a) {
      return a.offsetParent !== null && percorso(a) === href;
    }) || null;
  }
  // finito di rimettere il punto, lo scorrimento torna al browser: così anche lui, tornando, rimette la pagina dove era
  function scorrimentoAlBrowser() { try { if ('scrollRestoration' in history) history.scrollRestoration = 'auto'; } catch (x) {} }
  // la borsa in cima allo schermo (sotto la testata): tornando, si rimette lei allo stesso punto
  function inCima() {
    var carte = document.querySelectorAll('main a[href*="/products/"]');
    for (var i = 0; i < carte.length; i++) {
      var c = carte[i];
      if (c.offsetParent === null) continue;
      var r = c.getBoundingClientRect();
      if (r.bottom > 90 && r.height > 40) return c;
    }
    return null;
  }
  function fotografa(link) {
    if (ripristino) return;
    // toccata una borsa, il punto resta quello del tocco: lo scorrimento che arriva dopo (l'inerzia del dito) non lo cambia
    if (!link && Date.now() < congela) return;
    var s = { avY: Math.round(window.scrollY), avAncora: null, avAlto: null,
              avX: [].map.call(document.querySelectorAll(FILE_LATERALI), function (el) { return Math.round(el.scrollLeft); }) };
    if (link && link.closest('main')) { s.avAncora = percorso(link); s.avAlto = Math.round(link.getBoundingClientRect().top); }
    statoAv(s);
    ultimo = s;
    var pezzo = s.avAncora && /\/products\//.test(s.avAncora);
    if (pezzo && !/\/products\//.test(location.pathname)) {
      congela = Date.now() + 10000;
      try { sessionStorage.setItem('av_ritorno', JSON.stringify({ u: QUI, to: s.avAncora, t: Date.now() })); } catch (x) {}
    }
    if (!LISTA || (link && !pezzo)) return;
    var c = pezzo ? link : inCima();
    scriviLista({ u: QUI, y: s.avY, a: c ? percorso(c) : null, alto: c ? Math.round(c.getBoundingClientRect().top) : null,
                  pagine: (history.state || {}).avPagine || [], t: Date.now() });
  }
  var fermo;
  document.addEventListener('scroll', function () {
    clearTimeout(fermo);
    fermo = setTimeout(function () { fotografa(null); }, 250);
  }, { capture: true, passive: true });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('data-vedi-altre') || a.origin !== location.origin) return;
    if (a.pathname === location.pathname && a.hash) return;
    fotografa(a);
  }, true);
  // tornando con la pagina intatta dalla memoria del browser (Instagram e Safari su iPhone lo fanno quasi sempre) lo script
  // non riparte, e l'iPhone può rimettere la pagina in cima (04/11, video di Angelo: Nuovi arrivi -> Bottega Veneta -> «<»
  // di Instagram -> in cima). Si rimette il punto da qui, più volte nel primo secondo e mezzo, e intanto la cima non si salva.
  function rimettiDallaMemoria(p) {
    if (!p || (p.avY == null && !p.avAncora)) return;
    ripristino = true;
    var dal = Date.now(), basta = false;
    var tocco = function () { if (Date.now() - dal > 300) { basta = true; ripristino = false; } };
    window.addEventListener('touchstart', tocco, { passive: true });
    window.addEventListener('wheel', tocco, { passive: true });
    var un = function () {
      if (basta) return;
      document.querySelectorAll(FILE_LATERALI).forEach(function (el, k) {
        var x = (p.avX || [])[k];
        if (x != null && Math.abs(el.scrollLeft - x) > 2) el.scrollLeft = x;
      });
      var a = ancora(p.avAncora);
      var y = a && p.avAlto != null ? window.scrollY + a.getBoundingClientRect().top - p.avAlto : (p.avY || 0);
      y = Math.max(0, Math.round(y));
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
    };
    un();
    if (window.requestAnimationFrame) requestAnimationFrame(un);
    [50, 150, 300, 600, 1000, 1600].forEach(function (t) { setTimeout(un, t); });
    setTimeout(function () {
      window.removeEventListener('touchstart', tocco);
      window.removeEventListener('wheel', tocco);
      if (!basta) ripristino = false;
    }, 1700);
  }
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    congela = 0;
    try { sessionStorage.setItem('av_ultima', QUI); } catch (x) {}
    mostra();
    var h = history.state || {};
    rimettiDallaMemoria(ultimo || (h.avY != null ? h : null));
  });
  // niente salvataggi mentre si lascia la pagina: su Safari (iPhone) finivano sulla pagina dopo e svuotavano questa (27/10)

  // ---------------------------------------------------------------- si torna: da dove si riparte
  var giro = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {},
      tipo = giro.type || (window.performance && performance.navigation && performance.navigation.type === 2 ? 'back_forward' : 'navigate'),
      st = history.state || {}, prima = null;
  if (tipo === 'back_forward' && (st.avY != null || st.avX || (st.avPagine || []).length)) {
    prima = st;   // la voce della cronologia: il punto esatto di quella visita
  } else if (LISTA && !location.hash && !(tipo === 'navigate' && ULTIMA === QUI)) {
    var r = leggiLista(QUI);
    if (r) {
      prima = { avY: r.y, avAncora: r.a, avAlto: r.alto, avX: [], avPagine: r.pagine || [] };
      statoAv({ avPagine: prima.avPagine.slice() });   // «Vedi altre» dopo continua da qui
    }
  }
  if (!prima && (st.avPagine || []).length) statoAv({ avPagine: [] });   // la lista aperta da capo: niente pagine della volta prima

  if (!prima) {
    mostra();
    scorrimentoAlBrowser();
  } else {
    ripristino = true;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    // un tocco della persona ferma i ritocchi, ma solo dopo che il punto è stato rimesso la prima volta
    var toccato = false, rimesso = false;
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, function () { if (rimesso && !toccato) { toccato = true; ripristino = false; scorrimentoAlBrowser(); } }, { passive: true });
    });
    var applica = function () {
      if (toccato) return;
      document.querySelectorAll(FILE_LATERALI).forEach(function (el, k) {
        var x = (prima.avX || [])[k];
        if (x) el.scrollLeft = x;
      });
      var a = ancora(prima.avAncora);
      if (a && prima.avAlto != null) window.scrollTo(0, Math.max(0, window.scrollY + a.getBoundingClientRect().top - prima.avAlto));
      else window.scrollTo(0, prima.avY || 0);
      rimesso = true;
      mostra();
    };
    var fatto = function () {
      applica();
      // la pagina finisce di caricarsi (foto, caratteri, app): si rimette a posto ancora, se nessuno ha toccato lo schermo
      if (document.readyState !== 'complete') window.addEventListener('load', applica);
      setTimeout(applica, 400);
      setTimeout(applica, 1200);
      setTimeout(function () { applica(); ripristino = false; scorrimentoAlBrowser(); }, 2500);
    };
    var parti = function () {
    var dapagine = (prima.avPagine || []).slice();
    var m = memoria();
    if (dapagine.length && m.length === dapagine.length && m.every(function (x, i) { return x.u === dapagine[i]; })) {
      // subito, dalla memoria: niente attesa, niente pagina in alto mentre si riscarica
      m.forEach(function (x) { aggiungiCarte(x.html, x.dopo); });
      fatto();
    } else if (dapagine.length) {
      // le pagine viste con «Vedi altre» si riscaricano; intanto si scende fin dove arriva la lista (senza contarlo come rimesso)
      window.scrollTo(0, prima.avY || 0); mostra();
      var prossima = function () {
        var u = dapagine.shift();
        if (!u) { fatto(); return; }
        return caricaAltre(u).then(function (pezzo) {
          var mm = memoria(); mm.push(pezzo); salva(MEMORIA, JSON.stringify(mm));
          return prossima();
        }, fatto);
      };
      try { sessionStorage.removeItem(MEMORIA); } catch (x) {}
      prossima();
    } else {
      fatto();
    }
    };
    // subito dopo il resto di questo file (prima che la pagina si disegni): così il filtro per modello ha già messo le sue schede
    if (window.Promise) Promise.resolve().then(parti); else parti();
  }

  // ---------------------------------------------------------------- dalla scheda: il link alla lista fa come il tasto indietro
  // (briciole «Borse», menu): si torna alla stessa voce della cronologia, com'era, anche dove il tasto indietro non si vede
  if (/\/products\//.test(location.pathname)) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank' || history.length < 2) return;
      if ((history.state || {}).avZoom) return;
      var r = null, u, da;
      try { r = JSON.parse(sessionStorage.getItem('av_ritorno') || 'null'); } catch (x) {}
      if (!r || r.to !== location.pathname || Date.now() - r.t > DURATA) return;
      try { u = new URL(a.href, location.href); da = new URL(document.referrer); } catch (x) { return; }
      var pulito = function (p) { return p.replace(/\/+$/, '') || '/'; };
      if (u.origin !== location.origin || da.origin !== location.origin || da.pathname + da.search !== r.u) return;
      if (u.hash || pulito(u.pathname) !== pulito(r.u.split('?')[0])) return;
      e.preventDefault();
      history.back();
    }, true);
  }
})();

(function () {
  var b = document.body;
  var K = window.avKlaviyo || {};
  var REV = '2025-01-15';

  // ---------------------------------------------------------------- Klaviyo (Client API: solo chiave pubblica)
  function kPost(percorso, dati) {
    return fetch('https://a.klaviyo.com/client/' + percorso + '?company_id=' + encodeURIComponent(K.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: REV },
      body: JSON.stringify({ data: dati })
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
  }
  function iscrivi(email, lista, fonte, props) {
    if (!lista) return Promise.reject(new Error('lista Klaviyo non impostata'));
    var attr = { email: email };
    if (props) attr.properties = props;
    return kPost('subscriptions', {
      type: 'subscription',
      attributes: { custom_source: fonte, profile: { data: { type: 'profile', attributes: attr } } },
      relationships: { list: { data: { type: 'list', id: lista } } }
    });
  }
  function evento(email, nome, props) {
    return kPost('events', {
      type: 'event',
      attributes: {
        properties: props || {},
        metric: { data: { type: 'metric', attributes: { name: nome } } },
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }
    });
  }
  function tornaDisponibile(email, variante) {
    return kPost('back-in-stock-subscriptions', {
      type: 'back-in-stock-subscription',
      attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variante } } }
    });
  }
  function emailValida(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }
  window.avKlaviyoIscrivi = iscrivi;

  // ---------------------------------------------------------------- galleria: contatore e miniature che seguono lo scorrimento
  document.querySelectorAll('.av .galleria').forEach(function (g) {
    var t = g.querySelector('.binario'), c = g.querySelector('.contatore b'),
        m = [].slice.call(g.querySelectorAll('.miniature button'));
    if (!t) return;
    function qui() {
      var k = Math.round(t.scrollLeft / t.clientWidth);
      m.forEach(function (p, j) { p.classList.toggle('on', j === k); });
      if (c) c.textContent = k + 1;
      var x = m[k];
      if (x) { var st = x.parentNode; st.scrollTo({ left: x.offsetLeft - st.clientWidth / 2 + x.clientWidth / 2, behavior: 'smooth' }); }
    }
    t.addEventListener('scroll', function () { window.requestAnimationFrame(qui); }, { passive: true });
    m.forEach(function (p, j) { p.addEventListener('click', function () { t.scrollTo({ left: j * t.clientWidth, behavior: 'smooth' }); }); });
    // ingrandimento (Angelo 17/10: le clienti vogliono allargare le foto): tocco sulla foto o sulla lente
    var imgs = [].slice.call(t.querySelectorAll('figure img'));
    if (!imgs.length) return;
    imgs.forEach(function (im, j) { im.addEventListener('click', function () { apriZoom(imgs, j); }); });
    var lente = document.createElement('button');
    lente.type = 'button'; lente.className = 'av-lente'; lente.setAttribute('aria-label', 'Ingrandisci la foto');
    lente.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
    lente.addEventListener('click', function () { apriZoom(imgs, Math.round(t.scrollLeft / t.clientWidth)); });
    g.appendChild(lente);
  });

  // ---------------------------------------------------------------- ricerca che capisce gli errori (Angelo 19/10: «spedi» -> Speedy)
  // il dizionario sono le parole vere del catalogo (assets/av-parole.json, da controlli/parole_ricerca.py). Si corregge solo
  // quando la ricerca non trova niente: nella ricerca veloce (predictive-search.js) e nella pagina dei risultati.
  var DIZ = null, SUONI = null, dizInArrivo = null;
  function senzaAccenti(w) { return w.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function suono(w) { return senzaAccenti(w).replace(/ph/g, 'f').replace(/y/g, 'i').replace(/k/g, 'c').replace(/h/g, '').replace(/(.)\1+/g, '$1'); }
  function suoni(w) { var n = senzaAccenti(w); return [suono(n), suono(n.replace(/ee/g, 'i').replace(/oo/g, 'u'))]; }   // anche come si legge in inglese: speedy = «spidi»
  function caricaParole() {
    if (DIZ) return Promise.resolve();
    if (!dizInArrivo) {
      dizInArrivo = fetch(window.avParoleUrl).then(function (r) { return r.json(); }).then(function (d) {
        DIZ = d; SUONI = {};
        Object.keys(d).forEach(function (w) { suoni(w).forEach(function (f) { if (!SUONI[f] || d[w] > d[SUONI[f]]) SUONI[f] = w; }); });
      }).catch(function () { DIZ = {}; SUONI = {}; });
    }
    return dizInArrivo;
  }
  function distanza(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) d[i] = [i];
    for (j = 0; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) {
      var minimo = 99;
      for (j = 1; j <= b.length; j++) {
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        if (d[i][j] < minimo) minimo = d[i][j];
      }
      if (minimo > max) return max + 1;
    }
    return d[a.length][b.length];
  }
  function parolaGiusta(w) {
    var n = senzaAccenti(w);
    if (n.length < 3 || DIZ[n]) return w;
    var ss = suoni(n);
    if (SUONI[ss[0]]) return SUONI[ss[0]];
    if (SUONI[ss[1]]) return SUONI[ss[1]];
    var max = n.length >= 7 ? 2 : (n.length >= 4 ? 1 : 0), meglio = null, md = max + 1, mf = 0;
    if (!max) return w;
    Object.keys(DIZ).forEach(function (c) {
      var dd = distanza(n, c, max);
      if (dd < md || (dd === md && DIZ[c] > mf)) { md = dd; mf = DIZ[c]; meglio = c; }
    });
    return md <= max ? meglio : w;
  }
  window.avCorreggiRicerca = function (q) {
    return caricaParole().then(function () { return String(q || '').replace(/[A-Za-zÀ-ÿ]+/g, parolaGiusta); });
  };
  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('input[type="search"], input[name="q"]')) caricaParole();
  });
  (function () {
    var r = document.querySelector('[data-av-ricerca]');
    if (!r) return;
    var qs = new URLSearchParams(location.search), scritta = qs.get('av_cercato');
    if (scritta) {
      var nota = document.createElement('p');
      nota.className = 'av-ricerca-nota';
      var ancora = new URLSearchParams(location.search); ancora.set('q', scritta); ancora.delete('av_cercato'); ancora.set('av_esatto', '1');
      nota.innerHTML = 'Hai scritto «<b></b>»: ti mostriamo i risultati per «<b></b>». <a>Cerca invece «<span></span>»</a>';
      var bb = nota.querySelectorAll('b'); bb[0].textContent = scritta; bb[1].textContent = r.getAttribute('data-termini');
      nota.querySelector('span').textContent = scritta; nota.querySelector('a').href = location.pathname + '?' + ancora.toString();
      r.parentNode.insertBefore(nota, r.nextSibling);
      return;
    }
    // ricerca per codice del pezzo («AV946», il Riferimento della scheda): nelle ricerche senza risultati di ottobre
    // erano quasi tutte codici. Un pezzo solo: si apre la sua scheda. Nessuno: si spiega e si chiede su WhatsApp.
    var codice = (r.getAttribute('data-termini') || '').replace(/\s+/g, '').toUpperCase();
    if (r.getAttribute('data-fatta') === 'true' && /^[A-Z]{2}\d{3,4}$/.test(codice)) {
      var trovati = +r.getAttribute('data-trovati');
      var unico = trovati === 1 && document.querySelector('main a[href*="/products/"]');
      if (unico) { location.replace(unico.href); return; }
      if (trovati === 0) {
        var avviso = document.createElement('div');
        avviso.className = 'av-ricerca-nota av-codice';
        avviso.innerHTML = '<p>Il codice <b></b> non corrisponde a nessun pezzo online in questo momento: può essere già venduto o non ancora pubblicato.</p>' +
          '<a class="button" target="_blank" rel="noopener">Chiedi di questo pezzo su WhatsApp</a>';
        avviso.querySelector('b').textContent = codice;
        avviso.querySelector('a').href = 'https://wa.me/393336834578?text=' +
          encodeURIComponent('Ciao, vi scrivo dal sito: cerco il pezzo con codice ' + codice + ', è ancora disponibile?');
        // sotto il campo di ricerca, al posto di «Controlla l'ortografia» (qui l'ortografia è giusta)
        var testa = document.querySelector('.template-search__header');
        if (testa) {
          testa.querySelectorAll('p').forEach(function (p) { if (/Nessun risultato/i.test(p.textContent)) p.hidden = true; });
          testa.appendChild(avviso);
        } else {
          r.parentNode.insertBefore(avviso, r.nextSibling);
        }
        return;
      }
    }
    if (r.getAttribute('data-fatta') !== 'true' || +r.getAttribute('data-trovati') > 4 || qs.get('av_esatto')) return;   // pochi o nessun risultato
    var q = r.getAttribute('data-termini');
    window.avCorreggiRicerca(q).then(function (giusta) {
      if (!giusta || giusta.toLowerCase() === String(q).toLowerCase()) return;
      qs.set('q', giusta); qs.set('av_cercato', q);
      location.replace(location.pathname + '?' + qs.toString());
    });
  })();

  // ---------------------------------------------------------------- spazi nei testi scritti a mano (Angelo 19/10)
  // nelle descrizioni delle schede e nelle pagine: niente spazio prima di , . ; : ! ?, uno spazio dopo la virgola,
  // spazi normali al posto di quelli «fissi» copiati dall'editor (andavano a capo male). Le recensioni restano come sono.
  function sistemaSpazi(radice) {
    var w = document.createTreeWalker(radice, NodeFilter.SHOW_TEXT), n, nodi = [];
    while ((n = w.nextNode())) nodi.push(n);
    nodi.forEach(function (t) {
      if (!t.parentElement || t.parentElement.closest('.recensioni, script, style')) return;
      var v = t.nodeValue;
      var x = v.replace(/\u00a0/g, ' ').replace(/ {2,}/g, ' ').replace(/(\S) +([,.;:!?])(?=\s|$)/g, '$1$2').replace(/([,;])(?=[A-Za-zÀ-ÿ])/g, '$1 ');
      if (x !== v) t.nodeValue = x;
    });
  }
  document.querySelectorAll('[data-av-testo-cliente], .rte').forEach(sistemaSpazi);

  // ---------------------------------------------------------------- foto a schermo intero: si scorrono, un tocco ingrandisce
  var zoom = null;
  function grande(im) {
    var u = im.currentSrc || im.src || '';
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=2400') : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=2400';
  }
  function apriZoom(imgs, da) {
    if (!zoom) {
      zoom = document.createElement('div');
      zoom.className = 'av-zoom'; zoom.setAttribute('role', 'dialog'); zoom.setAttribute('aria-modal', 'true'); zoom.setAttribute('aria-label', 'Foto ingrandite');
      zoom.innerHTML = '<div class="av-zoom-binario"></div><div class="av-zoom-conta"></div>' +
        '<button type="button" class="av-zoom-chiudi" aria-label="Chiudi">&times;</button>' +
        '<button type="button" class="av-zoom-freccia av-zoom-prec" aria-label="Foto precedente">&#8249;</button>' +
        '<button type="button" class="av-zoom-freccia av-zoom-succ" aria-label="Foto successiva">&#8250;</button>' +
        '<div class="av-zoom-aiuto">Tocca la foto per ingrandirla</div>';
      document.body.appendChild(zoom);
      var bin = zoom.querySelector('.av-zoom-binario');
      bin.addEventListener('scroll', function () { window.requestAnimationFrame(contaZoom); }, { passive: true });
      zoom.querySelector('.av-zoom-chiudi').addEventListener('click', function () { chiudiZoom(true); });
      zoom.querySelector('.av-zoom-prec').addEventListener('click', function () { vaiZoom(-1); });
      zoom.querySelector('.av-zoom-succ').addEventListener('click', function () { vaiZoom(1); });
      document.addEventListener('keydown', function (e) {
        if (!zoom.classList.contains('aperto')) return;
        if (e.key === 'Escape') chiudiZoom(true);
        if (e.key === 'ArrowRight') vaiZoom(1);
        if (e.key === 'ArrowLeft') vaiZoom(-1);
      });
      window.addEventListener('popstate', function () { if (zoom.classList.contains('aperto')) chiudiZoom(false); });
    }
    var bin2 = zoom.querySelector('.av-zoom-binario');
    bin2.innerHTML = '';
    imgs.forEach(function (im) {
      var p = document.createElement('div'); p.className = 'av-zoom-pag';
      var x = document.createElement('img'); x.src = grande(im); x.alt = im.alt || ''; x.draggable = false; x.decoding = 'async';
      x.addEventListener('click', function (e) { ingrandisci(p, x, e); });
      p.addEventListener('mousemove', function (e) {
        if (!p.classList.contains('zoom') || !window.matchMedia('(hover: hover)').matches) return;
        var r = p.getBoundingClientRect();
        p.scrollLeft = (e.clientX - r.left) / r.width * (p.scrollWidth - p.clientWidth);
        p.scrollTop = (e.clientY - r.top) / r.height * (p.scrollHeight - p.clientHeight);
      });
      p.appendChild(x); bin2.appendChild(p);
    });
    zoom.classList.toggle('una', imgs.length < 2);
    zoom.classList.add('aperto'); document.documentElement.classList.add('av-zoom-aperto');
    bin2.scrollLeft = da * bin2.clientWidth;
    contaZoom();
    var aiuto = zoom.querySelector('.av-zoom-aiuto');
    aiuto.classList.add('vedi'); setTimeout(function () { aiuto.classList.remove('vedi'); }, 2600);
    try { history.pushState({ avZoom: 1 }, ''); } catch (x) {}
    zoom.querySelector('.av-zoom-chiudi').focus({ preventScroll: true });
  }
  function contaZoom() {
    var bin = zoom.querySelector('.av-zoom-binario'), n = bin.children.length;
    var k = Math.round(bin.scrollLeft / Math.max(1, bin.clientWidth));
    zoom.querySelector('.av-zoom-conta').textContent = n > 1 ? (k + 1) + ' / ' + n : '';
  }
  function vaiZoom(d) {
    var bin = zoom.querySelector('.av-zoom-binario');
    togliIngrandimento();
    var k = Math.round(bin.scrollLeft / bin.clientWidth) + d;
    k = Math.max(0, Math.min(bin.children.length - 1, k));
    bin.scrollTo({ left: k * bin.clientWidth, behavior: 'smooth' });
  }
  function ingrandisci(p, x, e) {
    if (p.classList.contains('zoom')) { togliIngrandimento(); return; }
    var r = x.getBoundingClientRect();
    var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
    var w = Math.min(Math.max(x.naturalWidth || 0, r.width * 1.8), r.width * 3.5);   // fino alla risoluzione vera della foto
    p.classList.add('zoom'); zoom.classList.add('zoomata');
    x.style.width = w + 'px';
    p.scrollLeft = fx * x.offsetWidth - p.clientWidth / 2;
    p.scrollTop = fy * x.offsetHeight - p.clientHeight / 2;
  }
  function togliIngrandimento() {
    if (!zoom) return;
    zoom.classList.remove('zoomata');
    zoom.querySelectorAll('.av-zoom-pag.zoom').forEach(function (p) { p.classList.remove('zoom'); p.scrollTop = 0; p.scrollLeft = 0; p.querySelector('img').style.width = ''; });
  }
  function chiudiZoom(indietro) {
    togliIngrandimento();
    zoom.classList.remove('aperto'); document.documentElement.classList.remove('av-zoom-aperto');
    if (indietro && history.state && history.state.avZoom) { try { history.back(); } catch (x) {} }
  }

  // ---------------------------------------------------------------- varianti che non sono colori (es. lo stile di un charm)
  document.querySelectorAll('.av-varianti [data-av-variante]').forEach(function (bt) {
    bt.addEventListener('click', function () {
      var box = bt.closest('.av-scheda'), id = box && box.querySelector('#compra input[name="id"]');
      if (!id) return;
      id.value = bt.getAttribute('data-av-variante');
      bt.parentNode.querySelectorAll('[data-av-variante]').forEach(function (x) { x.classList.toggle('on', x === bt); });
      var n = box.querySelector('[data-av-var-nome]'); if (n) n.textContent = bt.getAttribute('data-nome');
      var pr = box.querySelector('.prezzo'); if (pr) pr.textContent = bt.getAttribute('data-prezzo');
    });
  });

  // ---------------------------------------------------------------- gli stessi modelli in altri colori (scheda prodotto)
  var COLORI = {"blu cielo": "#8DAFD8", "blu": "#2C4A7A", "azzurro": "#9CC0E3", "nero": "#151515", "nera": "#151515", "beige": "#D9C4A5",
    "rosso": "#A3262A", "rossa": "#A3262A", "bianco": "#F3EFE8", "bianca": "#F3EFE8", "bianco avorio": "#EFE6D4", "avorio": "#EFE6D4",
    "marrone": "#6B4A33", "cognac": "#9A5B2E", "rosa": "#E3B2BA", "grigio": "#9A9693", "verde": "#4E6B50", "oro": "#C9A659",
    "argento": "#C3C3C3", "bordeaux": "#6E1F2B", "arancione": "#D9772B", "viola": "#6E4F8A", "giallo": "#E3C34A", "fucsia": "#C8327A",
    "cammello": "#B98B5E", "multicolore": "conic-gradient(#A3262A,#E3C34A,#4E6B50,#2C4A7A,#A3262A)"};
  function hex(n) {
    n = (n || '').toLowerCase().trim();
    var k = Object.keys(COLORI).sort(function (a, b) { return b.length - a.length; }).find(function (x) { return n.indexOf(x) >= 0; });
    return k ? COLORI[k] : '#CFC6BC';
  }
  function euroCent(c) {
    var e = Math.floor(c / 100), d = c % 100, s = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (d ? s + ',' + (d < 10 ? '0' + d : d) : s) + ' €';
  }
  // i prezzi nella valuta di chi guarda (euro per l'Italia, la sua valuta per chi arriva dall'estero)
  function soldi(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    if (cur === 'EUR') return euroCent(c);
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(c / 100); } catch (x) { return euroCent(c); }
  }
  var CHIAVI = 'Brand|Modello|Materiale|Colore|Hardware|Misure|Condizioni|Accessori|Codice seriale|Codice Seriale|Numero seriale|Numero Seriale|numero seriale|N. seriale|Numero di serie|Seriale|Taglia|Descrizione';
  function campo(descr, k) {
    var t = (descr || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;|\u00a0/g, ' ').replace(/\s+/g, ' ');
    var m = t.match(new RegExp(k + '\\s*:\\s*(.*?)(?=\\s(?:' + CHIAVI + ')\\s*:|Guarda qui|$)'));
    return m ? m[1].trim().replace(/;$/, '').trim() : '';
  }
  // Angelo 21/10: un colore porta solo allo STESSO modello. Si confrontano i titoli senza marca e senza colore:
  // «Borsa Kate Saint Laurent blu» e «Borsa Kate Saint Laurent nera» sono lo stesso modello,
  // «Borsa Kate Small Tassel», «Clutch Kate» o «Wallet on Chain Kate» no.
  var TINTE = new RegExp('\\b(?:' + ['ner[oaie]', 'bianc(?:o|a|hi|he)', 'ross[oaie]', 'blu', 'navy', 'azzurr[oaie]', 'celest[ei]', 'beige',
    'marron[ei]', 'cognac', 'rosa', 'grigi[oa]?', 'grigie', 'verd[ei]', 'oro', 'dorat[oaie]', 'argent(?:o|at[oaie])', 'bordeaux', 'bordo',
    'arancion[ei]', 'arancio', 'viola', 'giall[oaie]', 'fucsia', 'cammello', 'camel', 'avorio', 'multicolor[ei]?', 'tortora', 'crema', 'panna',
    'bronzo', 'cuoio', 'taupe', 'kaki', 'khaki', 'senape', 'corallo', 'lilla', 'turchese', 'ecru', 'nude', 'cipria', 'petrolio', 'ottanio',
    'cielo', 'sabbia', 'tabacco', 'caramello', 'prugna', 'smeraldo', 'oliva', 'militare', 'bluette', 'indaco', 'mattone', 'salmone', 'menta',
    'lavanda', 'ghiaccio', 'antracite', 'moro', 'bicolor[ei]', 'chiar[oaie]', 'scur[oaie]', 'metallizzat[oaie]', 'e'].join('|') + ')\\b', 'g');
  var DI_PASSAGGIO = /\b(?:usat[oaie]|originale|vintage|second hand|pre owned|in pelle|ysl|yves|lv|bv)\b/g;
  function piano(t) {
    t = (t || '').toLowerCase();
    if (t.normalize) t = t.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return ' ' + t.replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  }
  function nucleo(titolo, marca) {
    var t = piano(titolo);
    piano(marca).trim().split(' ').forEach(function (w) { if (w) t = t.split(' ' + w + ' ').join(' '); });
    // le parole in ordine alfabetico: «Kate Wallet On Chain» e «Wallet on Chain Kate» sono lo stesso modello
    return t.replace(TINTE, ' ').replace(DI_PASSAGGIO, ' ').replace(/\s+/g, ' ').trim().split(' ').sort().join(' ');
  }
  function cerca(q) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide')
      .then(function (r) { return r.json(); })
      .then(function (d) { return ((d.resources || {}).results || {}).products || []; })
      .catch(function () { return []; });
  }
  document.querySelectorAll('[data-av-altri-colori]').forEach(function (seg) {
    var riga = seg.parentNode, opz = riga.closest('.opzione'), marca = seg.getAttribute('data-marca'),
        modello = seg.getAttribute('data-modello') || '', mod = piano(modello).trim(), h = seg.getAttribute('data-handle'),
        titolo = seg.getAttribute('data-titolo') || '', core = nucleo(titolo, marca), visti = {};
    visti[piano(seg.getAttribute('data-colore')).trim()] = 1;
    riga.querySelectorAll('.av-swatch').forEach(function (s) { visti[piano(s.textContent).trim()] = 1; });
    if (!window.fetch || !core) return;
    var domande = [cerca(marca + ' ' + core)];
    if (modello) domande.push(cerca(marca + ' ' + modello));
    Promise.all(domande).then(function (rs) {
      var lista = [], gia = {};
      rs.forEach(function (r) { r.forEach(function (p) { if (!gia[p.handle]) { gia[p.handle] = 1; lista.push(p); } }); });
      lista = lista.filter(function (p) { return p.handle !== h && p.vendor === marca && p.available !== false; });
      // il nome del modello quando la scheda non lo scrive (es. «Kate Small Tassel»): quello di un pezzo vicino, se è nel titolo
      if (!mod) lista.some(function (p) {
        var m = campo(p.body, 'Modello');
        if (m && piano(titolo).indexOf(' ' + piano(m).trim() + ' ') >= 0) { modello = m; mod = piano(m).trim(); return true; }
      });
      // la riga «Altri modelli»: un pezzo per modello, diverso da questo
      var vicini = [], nuclei = {};
      nuclei[core] = 1;
      if (mod) lista.forEach(function (p) {
        var n = nucleo(p.title, marca), pm = piano(campo(p.body, 'Modello')).trim();
        if (nuclei[n] || vicini.length >= 4) return;
        if (pm === mod || piano(p.title).indexOf(' ' + mod + ' ') >= 0) { nuclei[n] = 1; vicini.push(p); }
      });
      if (vicini.length && opz) {
        var box = document.createElement('div');
        box.className = 'opzione av-altri-modelli';
        box.innerHTML = '<div class="et">Altri modelli <b></b></div><div class="av-modelli"></div>';
        box.querySelector('b').textContent = modello.charAt(0).toUpperCase() + modello.slice(1);
        var dove = box.querySelector('.av-modelli');
        vicini.forEach(function (p) {
          var a = document.createElement('a'), nome = p.title;
          piano(marca).trim().split(' ').concat(['ysl', 'yves']).forEach(function (w) {
            if (w) nome = nome.replace(new RegExp('(^|\\s)' + w + '(?=\\s|$)', 'ig'), ' ');
          });
          a.className = 'av-modello'; a.href = '/products/' + p.handle;
          a.innerHTML = '<img alt="" loading="lazy" width="44" height="44"><span><em></em><small></small></span>';
          var img = p.featured_image && p.featured_image.url || p.image;
          if (img) a.querySelector('img').src = img + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
          else a.querySelector('img').remove();
          a.querySelector('em').textContent = nome.replace(/\s+/g, ' ').trim();
          a.querySelector('small').textContent = soldi(Math.round(parseFloat(p.price) * 100));
          dove.appendChild(a);
        });
        opz.parentNode.insertBefore(box, opz.nextSibling);
      }
      // i pallini: solo lo stesso modello in un altro colore
      var stessi = lista.filter(function (p) { return nucleo(p.title, marca) === core; }).slice(0, 6);
      return Promise.all(stessi.map(function (p) { return fetch('/products/' + p.handle + '.js').then(function (r) { return r.json(); }).catch(function () { return null; }); }));
    }).then(function (ps) {
      (ps || []).forEach(function (p) {
        if (!p || !p.available || !p.options || !p.options[0] || p.options[0].name !== 'Colore') return;
        var altro = piano(campo(p.description, 'Modello')).trim();
        if (altro && mod && altro !== mod) return;    // la descrizione dice un altro modello: non e' un altro colore
        var col = p.options[0].values[0] || '', dc = campo(p.description, 'Colore');
        if (!col || visti[piano(col).trim()]) return;   // stesso colore di questa o di una gia' mostrata
        visti[piano(col).trim()] = 1;
        var tinta = (dc && dc.toLowerCase().indexOf(col.toLowerCase()) >= 0) ? dc : col;
        var a = document.createElement('a');
        a.className = 'av-swatch'; a.href = '/products/' + p.handle;
        a.innerHTML = '<i style="background:' + hex(tinta) + '"></i>' + col.charAt(0).toUpperCase() + col.slice(1) + '<small>' + soldi(p.price) + '</small>';
        riga.appendChild(a);
      });
    }).catch(function () {});
  });

  // ---------------------------------------------------------------- «Tutte le opzioni» apre i pagamenti
  document.querySelectorAll('[data-apri-pagamenti]').forEach(function (a) {
    a.addEventListener('click', function () { var d = document.getElementById('pagamenti'); if (d) d.open = true; });
  });

  // ---------------------------------------------------------------- barra d'acquisto fissa su telefono
  var cta = document.querySelector('.av #compra'), fissa = document.querySelector('.av .compra-fissa');
  if (cta && fissa && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      var vista = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      fissa.classList.toggle('vista', vista);
      b.classList.toggle('av-fissa-vista', vista && window.innerWidth <= 820);
    }).observe(cta);
    var bott = fissa.querySelector('[data-aggiungi-fisso]');
    if (bott) bott.addEventListener('click', function (e) {
      e.preventDefault();
      var s = cta.querySelector('[type="submit"]');
      if (s) s.click();
    });
  }

  // ---------------------------------------------------------------- lista d'attesa (scheda di una borsa venduta)
  // Angelo, 16/10: l'avviso parte quando arriva una borsa della stessa marca e dello stesso modello (misura compresa).
  // Senza modello scritto: il «torna disponibile» di Klaviyo su questa stessa borsa.
  document.querySelectorAll('[data-lista-attesa]').forEach(function (box) {
    var f = box.querySelector('form'), ok = box.querySelector('.ok'), ko = box.querySelector('.ko');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (f.email.value || '').trim();
      if (!emailValida(email)) { f.email.focus(); return; }
      var d = box.dataset, coppia = d.modello ? d.marca + '|' + d.modello : '';
      var bott = f.querySelector('button'); bott.disabled = true;
      var lavori = K.listaIscritti ? [iscrivi(email, K.listaIscritti, "Lista d'attesa (scheda venduta)")] : [];
      if (coppia) {
        lavori.push(evento(email, "Lista d'attesa – richiesta",
          { marca: d.marca, modello: d.modello, coppia: coppia, handle: d.handle, url: d.url, titolo: d.titolo }));
      } else {
        lavori.push(tornaDisponibile(email, d.variante));
      }
      Promise.all(lavori).then(function () {
        if (ko) ko.style.display = 'none';
        ok.style.display = 'block';
        f.querySelector('.campo').style.display = 'none';
      }).catch(function () {
        bott.disabled = false;
        if (ko) ko.style.display = 'block';
      });
    });
  });

  // ---------------------------------------------------------------- iscrizione (newsletter in fondo e pop-up)
  document.querySelectorAll('form[data-av-iscrizione]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (f.email.value || '').trim();
      if (!emailValida(email)) { f.email.focus(); return; }
      var bott = f.querySelector('button'); if (bott) bott.disabled = true;
      iscrivi(email, K.listaIscritti, f.getAttribute('data-av-iscrizione')).then(function () {
        try { localStorage.setItem('av_iscritta', '1'); } catch (x) {}
        var box = f.closest('[data-av-box]') || f;
        var prima = box.querySelector('.prima'), dopo = box.querySelector('.dopo'), ok = box.querySelector('.ok');
        if (prima && dopo) { prima.style.display = 'none'; dopo.style.display = 'block'; }
        else if (ok) { ok.style.display = 'block'; f.querySelector('.campo').style.display = 'none'; }
      }).catch(function () {
        if (bott) bott.disabled = false;
        var ko = (f.closest('[data-av-box]') || f).querySelector('.ko');
        if (ko) ko.style.display = 'block';
      });
    });
  });

  // ---------------------------------------------------------------- collezione: pannello dei filtri e «Vedi altre»
  var pan = document.querySelector('[data-av-filtri]'), bf = document.querySelector('[data-apri-filtri]');
  if (pan && bf) {
    bf.addEventListener('click', function () {
      pan.hidden = !pan.hidden;
      bf.classList.toggle('aperto', !pan.hidden);
      bf.setAttribute('aria-expanded', String(!pan.hidden));
    });
    pan.addEventListener('change', function (e) {
      var i = e.target;
      if (i.type === 'radio') {
        pan.querySelectorAll('input[name="' + i.name + '"]').forEach(function (x) { x.closest('label').classList.toggle('on', x.checked); });
      } else if (i.type === 'checkbox') {
        i.closest('label').classList.toggle('on', i.checked);
      }
    });
    pan.addEventListener('submit', function () {
      // il prezzo: una scelta sola, due valori nell'indirizzo
      var pr = pan.querySelector('[data-prezzo]');
      if (pr) {
        var sc = pan.querySelector('input[name="av_prezzo"]:checked'), g = pr.querySelector('[data-gte]'), l = pr.querySelector('[data-lte]');
        var v = sc ? sc.value : '';
        g.value = v === 'b' ? 500 : (v === 'c' ? 1000 : (v ? '' : g.value));
        l.value = v === 'a' ? 500 : (v === 'b' ? 1000 : (v ? '' : l.value));
      }
      // niente parametri vuoti nell'indirizzo
      pan.querySelectorAll('input').forEach(function (x) {
        if (x.name === 'av_prezzo' || (x.type === 'hidden' && !x.value) || (x.name === 'av_modello' && !x.value.trim())) x.disabled = true;
      });
    });
  }
  // ---------------------------------------------------------------- collezione: filtro per modello (Daria 30/10)
  // «Marmont» si cerca nel titolo di tutti i pezzi della collezione (con i filtri e l'ordine scelti): l'elenco leggero arriva
  // da ?view=av-indice, le schede dei pezzi trovati da /products/…?view=av-carta. Tornando indietro si rimette dalla memoria.
  (function () {
    var cerca = (new URLSearchParams(location.search).get('av_modello') || '').trim();
    var campo = document.querySelector('[data-av-modello]');
    if (campo && cerca) campo.value = cerca;
    var grid = document.querySelector('[data-griglia]');
    if (!cerca || !grid) return;
    var norma = function (t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); };
    var parole = norma(cerca).split(' ').filter(Boolean);
    var vale = function (t) { var x = ' ' + norma(t) + ' '; return parole.every(function (w) { return x.indexOf(w) !== -1; }); };
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
    var senza = new URL(location.href); senza.searchParams.delete('av_modello'); senza.searchParams.delete('page');
    var CHIAVE = 'av_modello:' + location.pathname + location.search;
    var altre = document.querySelector('[data-altre]'); if (altre) altre.remove();
    var badge = document.querySelector('[data-apri-filtri] em');
    if (badge) { badge.hidden = false; badge.textContent = (parseInt(badge.textContent, 10) || 0) + 1; }
    var riga = document.querySelector('[data-modello-attivo]');
    function mostra(html, n) {
      grid.innerHTML = n ? html : '<p class="av-modello-cerco">Nessun pezzo «' + esc(cerca) + '» in questa collezione, con questi filtri.</p>';
      var q = document.querySelector('[data-quanti]'), t = document.querySelector('[data-totale]');
      if (q) q.textContent = n; if (t) t.textContent = n;
      if (riga) { riga.hidden = false; riga.innerHTML = '<span>Modello: <b>' + esc(cerca) + '</b> · ' + n + (n === 1 ? ' pezzo' : ' pezzi') + '</span><a href="' + esc(senza.pathname + senza.search) + '">Togli il modello</a>'; }
    }
    try { var m = JSON.parse(sessionStorage.getItem(CHIAVE) || 'null'); if (m) { mostra(m.html, m.n); return; } } catch (x) {}
    grid.innerHTML = '<p class="av-modello-cerco">Cerco «' + esc(cerca) + '» in tutta la collezione…</p>';
    var indice = new URL(senza); indice.searchParams.set('view', 'av-indice');
    var pagina = function (k) { var u = new URL(indice); u.searchParams.set('page', k); return fetch(u).then(function (r) { return r.text(); }).then(JSON.parse); };
    // le pagine dell'elenco tutte insieme: quante sono lo dice il totale della collezione (250 pezzi per pagina)
    var tot = parseInt((document.querySelector('[data-totale]') || {}).textContent, 10) || 250, stima = Math.max(1, Math.ceil(tot / 250)), giro = [];
    for (var k = 1; k <= stima; k++) giro.push(pagina(k));
    Promise.all(giro).then(function (pagine) {
      var resto = [];
      for (var k = stima + 1; k <= pagine[0].pagine; k++) resto.push(pagina(k));
      return Promise.all(resto).then(function (altre) { return pagine.concat(altre); });
    }).then(function (pagine) {
      var trovati = [];
      pagine.forEach(function (pg) { pg.p.forEach(function (x) { if (vale(x[1])) trovati.push(x[0]); }); });
      trovati = trovati.slice(0, 120);
      var carte = new Array(trovati.length), i = 0;
      function una() {
        if (i >= trovati.length) return Promise.resolve();
        var k = i++;
        return fetch('/products/' + encodeURIComponent(trovati[k]) + '?view=av-carta').then(function (r) { return r.text(); })
          .then(function (t) { carte[k] = t.trim().charAt(0) === '<' ? t : ''; }, function () { carte[k] = ''; }).then(una);
      }
      var dodici = []; for (var j = 0; j < 12; j++) dodici.push(una());
      return Promise.all(dodici).then(function () {
        var html = carte.join('');
        mostra(html, trovati.length);
        salva(CHIAVE, JSON.stringify({ html: html, n: trovati.length }));
      });
    }).catch(function () {
      grid.innerHTML = '<p class="av-modello-cerco">Non siamo riusciti a cercare il modello. <a href="' + esc(senza.pathname + senza.search) + '">Riprova senza</a>.</p>';
    });
  })();
  // la memoria della scheda del browser: sta nel blocco del ritorno alle liste, in cima al file
  function salva(k, v) { return window.avSalva ? window.avSalva(k, v) : false; }

  // ---------------------------------------------------------------- cassetto: ozono, consegna con PIN, «si abbina bene»
  // si aggiunge con /cart/add.js e si ridisegna il cassetto con le sezioni di Dawn; si toglie con il suo updateQuantity
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-av-aggiungi]');
    if (a) {
      e.preventDefault();
      a.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +a.getAttribute('data-av-aggiungi'), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status || !res.sections) { a.disabled = false; return; }
        if (drawer && drawer.renderContents) drawer.renderContents(res);
        document.dispatchEvent(new CustomEvent('av:carrello-aggiunto'));
      }).catch(function () { a.disabled = false; });
      return;
    }
    var t = e.target.closest('[data-av-togli]');
    if (t) {
      e.preventDefault();
      var items = document.querySelector('cart-drawer-items');
      t.disabled = true;
      if (items && items.updateQuantity) items.updateQuantity(t.getAttribute('data-av-togli'), 0, e);
    }
  });

  // ---------------------------------------------------------------- NUOVOSITO10 nel carrello di tutti (Simone 17/10)
  // mentre il codice vale (sab 17/10 04:00 – dom 18/10 23:59, ora italiana) si mette da solo appena c'è qualcosa
  // nel carrello: dopo ogni aggiunta e all'apertura di ogni pagina. ?av_prova_codice=XXX lo prova con un altro codice.
  var SCONTO = { codice: 'NUOVOSITO10', dal: Date.parse('2026-10-17T02:00:00Z'), al: Date.parse('2026-10-18T21:59:00Z') };
  try {
    var pc = (location.search.match(/[?&]av_prova_codice=([A-Za-z0-9_-]+)/) || [])[1];
    if (pc) sessionStorage.setItem('av_prova_codice', pc.toUpperCase());
    if (sessionStorage.getItem('av_prova_codice')) { SCONTO.codice = sessionStorage.getItem('av_prova_codice'); SCONTO.dal = 0; }
  } catch (x) {}
  var scontoInCorso = false;
  function ridisegnaCassetto(res, apri) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !res.sections) return;
    if (apri && drawer.renderContents) { drawer.renderContents(res); return; }
    (drawer.getSectionsToRender ? drawer.getSectionsToRender() : []).forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      var html = res.sections[s.id];
      if (!el || !html) return;
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
      if (src) el.innerHTML = src.innerHTML;
    });
  }
  function applicaSconto(apri) {
    var n = Date.now();
    if (scontoInCorso || n < SCONTO.dal || n > SCONTO.al) return;
    scontoInCorso = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var codici = (c.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
      if (!c.item_count || codici.indexOf(SCONTO.codice) > -1) { scontoInCorso = false; return; }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codici.concat(SCONTO.codice).join(','), sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        scontoInCorso = false;
        ridisegnaCassetto(res, apri);
        if (/^\/cart\/?$/.test(location.pathname)) { try { if (!sessionStorage.getItem('av_sconto_ricarica')) { sessionStorage.setItem('av_sconto_ricarica', '1'); location.reload(); } } catch (x) {} }
      });
    }).catch(function () { scontoInCorso = false; });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.source === 'product-form') setTimeout(function () { applicaSconto(true); }, 300); });
  }
  document.addEventListener('av:carrello-aggiunto', function () { applicaSconto(true); });
  applicaSconto(false);

  // ---------------------------------------------------------------- pop-up di iscrizione
  var pop = document.querySelector('[data-av-popup]');
  if (pop) {
    // ?av_popup=vendi (o =iscrizione): l'anteprima di una versione, senza cambiare le impostazioni e senza contare la sessione
    var prova = (location.search.match(/[?&]av_popup=(vendi|iscrizione)/) || [])[1];
    if (prova) pop.setAttribute('data-tipo', prova);
    var vendi = pop.getAttribute('data-tipo') === 'vendi';
    var SESS = 'av_popup_visto', apri = function () {
      if (b.classList.contains('overflow-hidden')) return; // il carrello è aperto: si riprova dopo
      if (!prova) {
        // il pop-up «vendi» lo vede anche chi è già iscritta: una volta per sessione, come l'altro
        try { if (sessionStorage.getItem(SESS) || (!vendi && localStorage.getItem('av_iscritta'))) return; sessionStorage.setItem(SESS, '1'); } catch (x) {}
      }
      b.classList.add('popup-aperto');
    };
    var chiudi = function () { b.classList.remove('popup-aperto'); };
    pop.querySelectorAll('[data-chiudi-popup]').forEach(function (x) { x.addEventListener('click', chiudi); });
    pop.addEventListener('click', function (e) { if (e.target === pop) chiudi(); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') chiudi(); });
    var p = location.pathname, escluse = ['/cart', '/checkout', '/account', '/password', '/policies', '/pages/vendi'];
    var no = !prova && escluse.some(function (x) { return p.indexOf(x) === 0; });
    if (!no) {
      var ritardo = prova ? 1500 : 7000; // Simone, 16/10: dopo 7 secondi, su telefono e computer
      setTimeout(apri, ritardo);
    }
  }
})();
